const endpoint = property => `/api/${property}/events/activities`;

export default ['api', function (api) {
    return {
        save: activity => {
            let url = activity.id ? `${endpoint(api.property())}/${activity.id}` : endpoint(api.property());

            return api.upload(url, activity).then(response => response.data);
        },
        delete: id => api.delete(`${endpoint(api.property())}/${id}`),
        findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
            return api.get(endpoint(api.property()) + (page ? '?page=' + (page) + (page > -1 ? '&perpage=' + (perpage || '20') : '') : '') + (deleted ? '&deleted=true' : ''))
                .then(response => response.data);
        },
        findById: id => {
            return api.get(`${endpoint(api.property())}/${id}`)
                .then(response => response.data);
        },
        toggleActive: id => {
            return api.get(`${endpoint(api.property())}/status/${id}`)
                .then(response => response.data);
        },
        search: (type, text, page = null) => {
            return api.get(`${endpoint(api.property())}?type=${type}&text=${text}` + (page ? '&page=' + page : ''))
                .then(response => response.data);
        },
        updatePriority: activity => {
            return api.post(`${endpoint(api.property())}/${activity.id}/priority?priority=${activity.priority}`);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/services/activities.service.js